import { DropDownItem, GenerateDropDownItems, SearchByItem } from "@app/shared/classes/general";
import { TableColumnDef } from "@app/shared/components/smart-data-grid/data-grid/data-grid.constants";
import { smartSearchType } from "@app/shared/components/smart-search-form/smart-search-form.constant";
import { CountryCodeTranslate } from "@app/shared/pipes/country-code-translate";
import { LocaleDate } from "@app/shared/pipes/locale-date";
import { SubRegion } from "@app/shared/classes/subRegion";
import { YearMonth } from "@app/shared/pipes/year-month";
import { CommonFieldName, CommonFieldLabel } from "@app/shared/constants";

export enum AchievementFieldName {
  driverName = "driverName",
  terminalId = "terminalId",
  terminalName = "terminalName",
  subRegionName = "subRegionName",
  country = "country",
  kpiName = "kpiName",
  mileage = "mileage",
  cylinder = "cylinder",
  achieveDate = "achieveDate",
  awardDate = "awardDate",
  pvaDate = "pvaDate",
  created_On = "created_On",
  created_By = "created_By",
  lastModified_On = "lastModified_On",
  lastModified_By = "lastModified_By",

  apexId = "apexId",
  fullName = "fullName",

  rowNum = "rowNum",
  errorMessage = "errorMessage"
};

enum FieldLabel {
  DRIVER_NAME = "ml_143908",
  TERMINAL = "ml_144113",
  TERMINAL_ID = "ml_143909",
  TERMINAL_NAME = "ml_143910",
  SUB_REGION = "ml_143911",
  COUNTRY = "ml_143912",
  KPI_NAME = "ml_143913",
  MILEAGE = "ml_144095",
  CYLINDER = "ml_144096",
  ACHIEVE_MONTH = "ml_144092",
  CREATED_BY = "ml_143916",
  CREATED_ON = "ml_143917",
  LAST_CHANGED_BY = "ml_143918",
  LAST_CHANGED_ON = "ml_143919",

  DRIVER_APEX_ID = "ml_143930",

  LINE_NUMBER = "ml_143953",
  IMPORT_FAILED_MESSAGE = "ml_143954"
}

const AchievementSearchByList: SearchByItem[] = [
  { searchBy: AchievementFieldName.apexId, searchByLabel: FieldLabel.DRIVER_APEX_ID },
  { searchBy: AchievementFieldName.fullName, searchByLabel: FieldLabel.DRIVER_NAME },
  { searchBy: AchievementFieldName.terminalId, searchByLabel: FieldLabel.TERMINAL, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: AchievementFieldName.subRegionName, searchByLabel: FieldLabel.SUB_REGION, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  {
    searchBy: AchievementFieldName.achieveDate, searchByLabel: FieldLabel.ACHIEVE_MONTH, searchByType: smartSearchType.dateRangeSelct
  },
  { searchBy: CommonFieldName.lastModified_By, searchByLabel: CommonFieldLabel.LAST_CHANGED_BY },
  { searchBy: CommonFieldName.lastModified_On, searchByLabel: CommonFieldLabel.LAST_CHANGED_ON, searchByType: smartSearchType.dateRangeSelct }
];

export const DataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.DRIVER_NAME,
    name: AchievementFieldName.driverName,
    sort: true,
    sortFieldName: AchievementFieldName.fullName
  },
  {
    text: FieldLabel.TERMINAL_ID,
    name: AchievementFieldName.terminalId,
    sort: true,
  },
  {
    text: FieldLabel.TERMINAL_NAME,
    name: AchievementFieldName.terminalName,
    sort: true
  },
  {
    text: FieldLabel.SUB_REGION,
    name: AchievementFieldName.subRegionName,
    sort: true
  },
  {
    text: FieldLabel.COUNTRY,
    name: AchievementFieldName.country,
    sort: true,
    pipe: CountryCodeTranslate
  },
  {
    text: FieldLabel.MILEAGE,
    name: AchievementFieldName.mileage,
    sort: true
  },
  {
    text: FieldLabel.CYLINDER,
    name: AchievementFieldName.cylinder,
    sort: true
  },
  {
    text: FieldLabel.ACHIEVE_MONTH,
    name: AchievementFieldName.achieveDate,
    sort: true,
    pipe: YearMonth
  },
  {
    text: FieldLabel.LAST_CHANGED_BY,
    name: AchievementFieldName.lastModified_By,
    sort: true
  },
  {
    text: FieldLabel.LAST_CHANGED_ON,
    name: AchievementFieldName.lastModified_On,
    sort: true,
    pipe: LocaleDate
  }
];

export const GetAchievementSearchByList = ([terminals, subRegions]: [DropDownItem[], SubRegion[]]) => {
  var result = AchievementSearchByList.slice();
  result[2].searchDropDownValue = terminals;
  result[3].searchDropDownValue = subRegions ? GenerateDropDownItems(subRegions.map(item => item.subRegionName)) : [];
  return result;
}

export const ImportResultDataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.LINE_NUMBER,
    name: AchievementFieldName.rowNum,
    sort: true,
    width: 5
  },
  {
    text: FieldLabel.IMPORT_FAILED_MESSAGE,
    name: AchievementFieldName.errorMessage,
    sort: true,
    width: 95
  }]
  ;
